import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ToggleSwitchButton',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  emits: ['update:modelValue'],
})
export default class ToggleSwitchButton extends Vue {
  modelValue!: boolean;
  disabled!: boolean;
  localValue: boolean = false;

  created() {
    this.localValue = !!this.modelValue;
  }
  toggleValue() {
    if(this.disabled)
      return;
    this.localValue = !this.localValue;
    this.$emit('update:modelValue', this.localValue)
  }
}
